module.exports = __webpack_public_path__ + "img/15.20f38189.jpg";